/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { header } from './layouts';
import { slider, tabs, accordion, aos } from './components';

import { loadPage } from './utils';

(function () {
  loadPage.init();

  // Layouts
  header.init();
  aos.init();


  // Partials Modules
  slider.init();
  tabs.init();
  accordion.init();


  // Page Modules
}());
